/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * <p>
 * Copyright © 2019 Pearson Education, Inc.
 * All Rights Reserved.
 * <p>
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 *
 * This is the data class for holding partner attributes.
 *
 * @author urahish
 * 12/23/2019
 *
 */

import React, {Fragment, Component} from 'react';
import './SignIn.css'
import ImgPearson from '../../assets/img/PearsonLogo_Horizontal_W_RGB.png'
import Loader from "../../components/generic/loader/loader";
import jwt_decode from 'jwt-decode'
import {Redirect} from "react-router-dom";
import axios from 'axios';
import { API_BASE_URL } from '../../utils/api';

class SignIn extends Component {
    user = JSON.parse(localStorage.getItem('tmcUser'));

    constructor(props) {
        super(props);

        this.state = {
            isDisplayLoader: false,
            isDisplayError: false,
            isAuthenticated: false,
            token: null,
            username: '',
            password: ''
        };

        if (this.user === undefined || this.user == null)
            localStorage.setItem('tmcUser', JSON.stringify({
                isAuthenticated: false,
                mail: null,
                token: null,
                tokenExp: null,
                role: null
            }));
    }

    /**
     * handle form submission
     * @returns {Promise<void>}
     */
    handleSubmit = async () => {
        // set a token to unsubscribe the async call
        const cancelToken = axios.CancelToken;
        const src = cancelToken.source();

        this.setState({isDisplayLoader: true});
        let baseurl = API_BASE_URL + '/tpimgr-authenticate';

        await axios.post(baseurl, {
            username: this.state.username,
            userPswrd: this.state.password
        }, {cancelToken: src.token}).then(res => {
            let decoded = jwt_decode(res.data.token);

            localStorage.setItem('tmcUser', JSON.stringify({
                isAuthenticated: true,
                mail: this.state.username,
                token: res.data.token,
                tokenExp: decoded.exp,
                role: decoded.role[0].authority
            }));
            this.setState({
                isDisplayLoader: false,
                token: res.data.token,
                isAuthenticated: true,
                username: '',
                password: ''
            });
            this.props.history.push('/home');
        }).catch(err => {
            localStorage.setItem('tmcUser',JSON.stringify({
                isAuthenticated: false,
                mail: null,
                token: null,
                tokenExp: null,
                role: null
            }));
            this.setState({
                isDisplayLoader: false,
                token: null,
                isAuthenticated: false,
                username: '',
                password: ''
            });
            this.displayError();
        });

        src.cancel();
    };

    /**
     * display error message
     */
    displayError = () => {
        this.setState({isDisplayError: true});
        setTimeout(() => {
            this.setState({isDisplayError: false})
        }, 5000);
    };

    render() {
        let user = JSON.parse(localStorage.getItem('tmcUser'));
        if (user.isAuthenticated)
            return <Redirect to='/home' />;
        return (
            <Fragment>
                {this.state.isDisplayLoader && <Loader/>}
                <div role="group" className="signIn-main-container" >
                    <header id="signIn-row1">
                        <div className="signIn-image-container">
                            <div className="signIn-logo-container">
                                <img src={ImgPearson} className="signIn-img-logo" alt="Pearson Logo"/>
                            </div>
                            <div className="signIn-div-app-name">
                                <p>TPI Management Console</p>
                            </div>
                        </div>
                    </header>
                    <main id="signIn-row2">
                        <div className="signIn-container">
                            <div className="signIn-form-container">
                                <form className="signIn-form">
                                    {this.state.isDisplayError && <div className='signIn-error'>
                                        <i className='fa fa-warning'/>
                                        <span>Invalid username or password</span>
                                    </div>}
                                    <h3 className="signIn-header">Sign In</h3>
                                    <fieldset>
                                        <label className="signIn-lbl" htmlFor="user-name">
                                            User Name
                                        </label>
                                        <input autoComplete="off" className="signIn-input" type="text"
                                               id="username" name="username" placeholder="" aria-label="username"
                                               value={this.state.username}
                                               onChange={v => this.setState({username: v.target.value})}
                                        />
                                    </fieldset>
                                    <fieldset>
                                        <label className="signIn-lbl" htmlFor="password">
                                            Password
                                        </label>
                                        <input autoComplete="off"  className="signIn-input" type="password"
                                               id="password" name="password" placeholder=""
                                               value={this.state.password}
                                               onChange={v => this.setState({password: v.target.value})}
                                               onKeyDown={e => {
                                                   if (e.keyCode === 13) {
                                                       this.handleSubmit();
                                                   }
                                               }}
                                        />
                                    </fieldset>
                                    <fieldset>
                                        <button type='button' className="signIn-btn" onClick={this.handleSubmit}>Sign In</button>
                                    </fieldset>
                                    <fieldset>
                                        <p> By signing in, you agree to our
                                            <a href="https://pi.pearsoned.com/v1/piapi/login/static/html/PearsonEULA.html">
                                                <u>Terms of Use</u>
                                            </a>
                                        </p>
                                    </fieldset>
                                </form>
                            </div>
                        </div>
                    </main>
                </div>
            </Fragment>
        );
    }
}

export default SignIn;
